var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import Pagination from '../../common/components/Pagination';
import ReportStockService from '../../api/ReportStockService';
import { UrlHelper } from '../../helper/UrlWrapper';
import { billDefaultDate } from '../../helper/defaultDate';
import QueryHeader from './components/QueryHeader';
import { getTheDayZeroTime } from '../../helper/util';
import { auth } from '../../helper/authDecorator';
import { nameDict } from '../../constant/authCode';
import BatchManage from './components/BatchManage.vue';
import TableList from '../../components/common/TableList.vue';
function getDefaultFormData() {
    var data = {
        depot_ids: [],
        keyword: '',
        goods_format_id: null,
        goods_type_id: null,
        s_time: billDefaultDate().Start.format('yyyy-MM-dd'),
        e_time: billDefaultDate().End.format('yyyy-MM-dd'),
    };
    return data;
}
var DetailList = (function (_super) {
    __extends(DetailList, _super);
    function DetailList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.service = ReportStockService.getInstance();
        _this.fetchAction = _this.service.getStockDetailList;
        _this.tableHeight = document.documentElement.clientHeight - 275;
        _this.sortColumns = ['goods_name', 'c_time'];
        _this.filter = {};
        _this.filterColumns = [];
        _this.formData = getDefaultFormData();
        _this.instructionsData = [
            {
                name: '变化数量',
                detail: '标记库存单位数量，如以采购单位入库，此处将按采购单位*采购系数自动转换成库存单位数量；如以销售单位出库，此处将以销售单位*销售系数自动转移成库存单位数量；出库为负，入库为正。',
            },
            {
                name: '变化金额',
                detail: '1、即单据含税金额；',
            },
            {
                name: '库存数量',
                detail: '对应仓库中对应货品在本次出入库后的总数量',
            },
            {
                name: '库存单价',
                detail: '库存金额/库存数量',
            },
            {
                name: '库存金额',
                detail: '对应仓库中对应货品在本次出入库后的总金额',
            },
            {
                name: '批次单号',
                detail: '货品入库的原始批次（采购入库、库存初始化、报溢）',
            },
            {
                name: '批次剩余量',
                detail: '以库存单位维度统计所在仓库中该批次在变化数量之后的剩余量。',
            },
            {
                name: '批次单价',
                detail: '本批次的单价',
            },
            {
                name: '批次剩余金额',
                detail: '批次单价*批次剩余库存；表示本批次的剩余金额（经过此次出入库后的本批次的剩余金额）',
            },
        ];
        return _this;
    }
    DetailList.prototype.created = function () {
        this.formData.depot_ids = this.depot_ids || [];
        this.formData.keyword = this.keyword || '';
        this.formData.goods_format_id = this.goods_format_id || null;
        var arr = [];
        if (!this.openedCodeData.isOpenMultOrg)
            arr.push('organ_name');
        if (!this.Root_PageAuth.WarningManage)
            arr = arr.concat(['production_date', 'shelflife', 'expire_date']);
        this.filterColumns = arr;
        this.initFilter();
    };
    DetailList.prototype.initFilter = function () {
        this.filter = {
            depot_ids: (this.formData.depot_ids || []).join(','),
            keyword: this.formData.keyword,
            goods_format_id: this.formData.goods_format_id,
            goods_type_id: this.formData.goods_type_id ? this.formData.goods_type_id : -1,
            s_time: this.formData.s_time,
            e_time: this.formData.e_time,
        };
    };
    DetailList.prototype.searchClick = function () {
        var _this = this;
        var timeDiff = getTheDayZeroTime(new Date(this.formData.e_time)) - getTheDayZeroTime(new Date(this.formData.s_time));
        if (timeDiff < 0 || timeDiff > 365 * 1000 * 24 * 60 * 60) {
            this.$message.warning('最大查询范围不可超过一年');
            return;
        }
        this.initFilter();
        this.$nextTick(function () {
            _this.$refs.TableList.fetch();
        });
    };
    DetailList.prototype.reset = function () {
        this.formData = getDefaultFormData();
        this.searchClick();
    };
    DetailList.prototype.exportData = function () {
        var url = 'supplierclientapi/report/export_stockio_list?';
        url = UrlHelper.addParam(url, 'depot_ids', (this.formData.depot_ids || []).join(','));
        url = UrlHelper.addParam(url, 'keyword', this.formData.keyword);
        url = UrlHelper.addParam(url, 'goods_type_id', this.formData.goods_type_id ? this.formData.goods_type_id : -1);
        url = UrlHelper.addParam(url, 's_time', this.formData.s_time);
        url = UrlHelper.addParam(url, 'e_time', this.formData.e_time);
        url = UrlHelper.addParam(url, 'token', this.user.token);
        location.href = url;
        window._czc.push(['_trackEvent', '出入库明细列表', '出入库明细导出']);
    };
    DetailList.prototype.batchManage = function () {
        var dialog = this.$dialog(BatchManage, {
            data: {
                "user": this.user,
                "pageAuths": this.Root_PageAuth
            },
        }, {
            title: '批次管理',
            width: 1200,
            height: 700,
        });
    };
    __decorate([
        Prop({
            type: Array,
        })
    ], DetailList.prototype, "depot_ids", void 0);
    __decorate([
        Prop({
            type: String,
        })
    ], DetailList.prototype, "keyword", void 0);
    __decorate([
        Prop({
            type: Number,
            default: 0
        })
    ], DetailList.prototype, "goods_format_id", void 0);
    DetailList = __decorate([
        Component({
            computed: __assign({}, mapGetters({
                user: 'user',
                openedCodeData: 'openedCodeData',
            })),
            components: {
                pagination: Pagination,
                'query-header': QueryHeader,
                TableList: TableList,
            },
        }),
        auth(nameDict['出入库明细'], true)
    ], DetailList);
    return DetailList;
}(Vue));
export default DetailList;
